import React, { Component } from "react";
import ReactTable from "react-table";
import axios from "axios";
import { Modal, Button, Badge, message } from "antd";
import { Button as ReactButton } from "reactstrap";
import DropdownBtn from "../components/DropdownBtn";
import PacksDrawer from "../components/PacksDrawer";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { packsValidator } from "../utils/packsValidator";

dayjs.extend(customParseFormat);

class SpecialPacks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      packs: [],
      current_uuid: "",
      openAlert: false,
      openModal: false,
      isNewService: false,
      pack: {
        title: "",
        postal_code: "",
        internet_data: { id: undefined, new_price: "" },
        phone_data: [],
        television_data: { id: undefined, new_price: "" },
        total_price: 0,
        start_day: undefined,
        end_day: dayjs().format("DD/MM/YYYY"),
      },
      formErrors: {},
    };

    this.handleRemove = this.handleRemove.bind(this);
    this.handleEditForm = this.handleEditForm.bind(this);
    this.handleAddPhone = this.handleAddPhone.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleCancelForm = this.handleCancelForm.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleTotalCalculate = this.handleTotalCalculate.bind(this);
  }
  componentDidMount() {
    this.getAllSpecialPacks();
  }
  getAllSpecialPacks() {
    axios.post("https://dev.nadu.xyz/dev/admin/getAllPacks").then((res) => {
      if (typeof res !== "undefined") {
        this.setState({
          packs: res.data.map((option) => {
            return {
              uuid: option.uuid,
              title: option.title,
              postal_code: option.postal_code,
              internet_data: option.internet_data,
              phone_data: option.phone_data,
              television_data: option.television_data,
              total_price: option.total_price,
              start_day: option.start_day,
              end_day: option.end_day,
              totalPrice: option.formatted_price,
              validPeriod: `${option.start_day} - ${option.end_day}`,
              services: (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    gap: "8px",
                  }}
                >
                  {option.internet_data && (
                    <i className="now-ui-icons business_globe" />
                  )}
                  {option.television_data && (
                    <i className="now-ui-icons tech_tv" />
                  )}
                  {option.phone_data && (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "4px",
                      }}
                    >
                      <Badge
                        size="small"
                        color="#46b98a"
                        count={
                          Array.isArray(option.phone_data)
                            ? option.phone_data.length
                            : 0
                        }
                      >
                        <i className="now-ui-icons tech_mobile" />
                      </Badge>
                    </span>
                  )}
                </div>
              ),
              actions: (
                <DropdownBtn
                  section={option}
                  handleEditSection={() =>
                    this.handleOpenModal(false, option.uuid)
                  }
                  handleDelete={() =>
                    this.setState({
                      openAlert: true,
                      current_uuid: option.uuid,
                    })
                  }
                />
              ),
            };
          }),
        });
      }
    });
  }
  handleOpenModal(isNew = false, uuid) {
    if (isNew) {
      this.setState({
        openModal: true,
        isNewService: true,
        pack: {
          title: "",
          postal_code: "",
          internet_data: { id: undefined, new_price: "" },
          phone_data: [],
          television_data: { id: undefined, new_price: "" },
          total_price: 0,
          start_day: undefined,
          end_day: undefined,
        },
      });
    } else {
      const selectedOption = this.state.packs.find(
        (elem) => elem.uuid === uuid
      );
      this.setState({
        openModal: true,
        isNewRate: false,
        pack: {
          uuid: selectedOption.uuid,
          postal_code: selectedOption.postal_code,
          title: selectedOption.title,
          internet_data: selectedOption.internet_data
            ? selectedOption.internet_data
            : { id: undefined, new_price: "" },
          phone_data: selectedOption.phone_data
            ? selectedOption.phone_data
            : [],
          television_data: selectedOption.television_data
            ? selectedOption.television_data
            : { id: undefined, new_price: "" },
          total_price: selectedOption.total_price,
          start_day: selectedOption.start_day,
          end_day: selectedOption.end_day,
        },
      });
    }
  }
  handleCancelForm() {
    this.setState({
      openModal: false,
      isNewService: false,
      pack: {
        uuid: "",
        title: "",
        internet_data: { id: "", new_price: "" },
        phone_data: [],
        television_data: { id: "", new_price: "" },
        total_price: "",
        start_day: "",
        end_day: "",
      },
      formErrors: {},
    });
  }
  handleDateChange(name, dateString) {
    if (name === "valid_range") {
      const [start_day, end_day] = dateString;
      // console.log(start_day, end_day);
      this.setState(
        {
          pack: {
            ...this.state.pack,
            start_day: start_day,
            end_day: end_day,
          },
        },
        () => this.validateAndSetErrors()
      );
    }
  }
  handleTotalCalculate() {
    let auxTotal = 0;
    const { pack } = this.state;
    if (pack.internet_data && pack.internet_data.new_price) {
      auxTotal += pack.internet_data.new_price
        ? Number(pack.internet_data.new_price)
        : 0;
    }
    if (pack.television_data && pack.television_data.new_price) {
      auxTotal += pack.television_data.new_price
        ? Number(pack.television_data.new_price)
        : 0;
    }
    if (pack.phone_data && pack.phone_data.length > 0) {
      pack.phone_data.map((phone) => {
        auxTotal += phone.new_price ? Number(phone.new_price) : 0;
      });
    }
    return auxTotal;
  }
  validateAndSetErrors() {
    const { pack } = this.state;
    const errors = packsValidator(pack);
    this.setState({ formErrors: errors });
  }
  handleInputChange(event, section, props, index) {
    if (typeof event === "string" && props) {
      if (section === "phone") {
        let allPhones = [...this.state.pack.phone_data];
        allPhones[index] = {
          id: props.uuid,
          new_price: Number(props.price),
        };
        this.setState(
          {
            pack: {
              ...this.state.pack,
              phone_data: allPhones,
            },
          },
          () => {
            this.setState({
              pack: {
                ...this.state.pack,
                total_price: this.handleTotalCalculate(),
              },
            });
            this.validateAndSetErrors();
          }
        );
      } else {
        this.setState(
          {
            pack: {
              ...this.state.pack,
              [`${section}_data`]: {
                id: props.uuid,
                new_price: Number(props.price),
              },
            },
          },
          () => {
            this.setState({
              pack: {
                ...this.state.pack,
                total_price: this.handleTotalCalculate(),
              },
            });
            this.validateAndSetErrors();
          }
        );
      }
    } else if (event === null) {
      this.setState(
        {
          pack: {
            ...this.state.pack,
            [`${section}_data`]: {
              id: undefined,
              new_price: "",
            },
          },
        },
        () => {
          this.setState({
            pack: {
              ...this.state.pack,
              total_price: this.handleTotalCalculate(),
            },
          });
          this.validateAndSetErrors();
        }
      );
    } else {
      const { name, value } = event.target;
      if (section === "phone") {
        let allPhones = [...this.state.pack.phone_data];
        const regex = /^(\d+(\.\d*)?|\.\d+)?$/;
        const normalizedValue = value.replace(",", ".");
        const newPrice = regex.test(normalizedValue)
          ? normalizedValue
          : allPhones[index].new_price;

        allPhones[index] = {
          ...allPhones[index],
          new_price: newPrice,
        };
        this.setState(
          {
            pack: {
              ...this.state.pack,
              phone_data: allPhones,
            },
          },
          () => {
            this.setState({
              pack: {
                ...this.state.pack,
                total_price: this.handleTotalCalculate(),
              },
            });
            this.validateAndSetErrors();
          }
        );
      } else if (
        event !== null &&
        (section === "television" || section === "internet")
      ) {
        const regex = /^(\d+(\.\d*)?|\.\d+)?$/;
        const normalizedValue = value.replace(",", ".");
        const newPrice = regex.test(normalizedValue)
          ? normalizedValue
          : this.state.pack[`${section}_data`].new_price;

        this.setState(
          {
            pack: {
              ...this.state.pack,
              [`${section}_data`]: {
                ...this.state.pack[`${section}_data`],
                new_price: newPrice,
              },
            },
          },
          () => {
            this.setState({
              pack: {
                ...this.state.pack,
                total_price: this.handleTotalCalculate(),
              },
            });
            this.validateAndSetErrors();
          }
        );
      } else {
        this.setState({ pack: { ...this.state.pack, [name]: value } }, () =>
          this.validateAndSetErrors()
        );
      }
    }
  }
  handleRemove(index) {
    let allPhones = [...this.state.pack.phone_data].filter(
      (_, idx) => idx !== index
    );
    this.setState(
      {
        pack: { ...this.state.pack, phone_data: allPhones },
      },
      () => {
        this.setState({
          pack: {
            ...this.state.pack,
            total_price: this.handleTotalCalculate(),
          },
        });
        this.validateAndSetErrors();
      }
    );
  }
  handleAddPhone() {
    let allPhones = [
      ...this.state.pack.phone_data,
      { id: undefined, new_price: "" },
    ];
    this.setState(
      {
        pack: { ...this.state.pack, phone_data: allPhones },
      },
      () =>
        this.setState({
          pack: {
            ...this.state.pack,
            total_price: this.handleTotalCalculate(),
          },
        })
    );
  }
  handleFormSubmit() {
    const { pack } = this.state;
    const formatted_internet = pack.internet_data.id
      ? {
          id: pack.internet_data.id,
          new_price: Number(pack.internet_data.new_price).toFixed(2),
        }
      : null;
    const formatted_television = pack.television_data.id
      ? {
          id: pack.television_data.id,
          new_price: Number(pack.television_data.new_price).toFixed(2),
        }
      : null;
    const formatted_phone =
      pack.phone_data.length > 0
        ? pack.phone_data.map((phone) => ({
            id: phone.id,
            new_price: Number(phone.new_price).toFixed(2),
          }))
        : null;
    const formattedBody = {
      params: {
        title: pack.title,
        internet_data: formatted_internet,
        phone_data: formatted_phone,
        television_data: formatted_television,
        total_price: pack.total_price,
        postal_code: pack.postal_code,
        start_day: pack.start_day,
        end_day: pack.end_day,
      },
    };
    axios
      .post("https://dev.nadu.xyz/dev/admin/createPack", formattedBody)
      .then((res) => {
        if (res.data.ok) {
          message.success(res.data.message);
          this.getAllSpecialPacks();
          this.setState({
            pack: {
              title: "",
              postal_code: "",
              internet_data: { id: "", new_price: "" },
              phone_data: [],
              television_data: { id: "", new_price: "" },
              total_price: "",
              start_day: "",
              end_day: "",
            },
            openModal: false,
            isNewService: false,
          });
        } else {
          message.error(res.data.error);
        }
      })
      .catch(() => message.error("Hubo un error al crear el servicio."));
  }
  handleEditForm() {
    const { pack } = this.state;
    const formatted_internet = pack.internet_data.id
      ? {
          id: pack.internet_data.id,
          new_price: Number(pack.internet_data.new_price).toFixed(2),
        }
      : null;
    const formatted_television = pack.television_data.id
      ? {
          id: pack.television_data.id,
          new_price: Number(pack.television_data.new_price).toFixed(2),
        }
      : null;
    const formatted_phone =
      pack.phone_data.length > 0
        ? pack.phone_data.map((phone) => ({
            id: phone.id,
            new_price: Number(phone.new_price).toFixed(2),
          }))
        : null;
    const formattedBody = {
      params: {
        node_id: pack.uuid,
        fields: {
          title: pack.title,
          internet_data: formatted_internet,
          phone_data: formatted_phone,
          television_data: formatted_television,
          total_price: pack.total_price,
          postal_code: pack.postal_code,
          start_day: pack.start_day,
          end_day: pack.end_day,
        },
      },
    };
    axios
      .post("https://dev.nadu.xyz/dev/admin/updatePack", formattedBody)
      .then((res) => {
        if (res.data.ok) {
          message.success(res.data.message);
          this.getAllSpecialPacks();
          this.setState({
            pack: {
              title: "",
              postal_code: "",
              internet_data: { id: "", new_price: "" },
              phone_data: [],
              television_data: { id: "", new_price: "" },
              total_price: "",
              start_day: "",
              end_day: "",
            },
            openModal: false,
            isNewService: false,
          });
        } else {
          message.error(res.data.error);
        }
      })
      .catch(() => message.error("Hubo un error al crear el servicio."));
  }
  handleDeleteService(uuid) {
    axios
      .post("https://dev.nadu.xyz/dev/admin/deletePack", { params: uuid })
      .then(() => {
        message.success("Servicio eliminado correctamente.");
        this.getAllSpecialPacks();
      })
      .catch(() => message.error("Hubo un error al eliminar el servicio."));
  }
  render() {
    return (
      <div>
        <div
          style={{
            marginTop: "10px",
            display: "flex",
            flexDirection: "column",
            alignItems: "end",
            justifyContent: "center",
          }}
        >
          <ReactButton
            style={{ width: "fit-content" }}
            onClick={() => this.handleOpenModal(true)}
          >
            Añadir Pack Especial
          </ReactButton>
          <ReactTable
            style={{ width: "100%" }}
            columns={[
              {
                Header: "Codigo Postal",
                accessor: "postal_code",
                sortable: false,
                filterable: false,
              },
              {
                Header: "Validez",
                accessor: "validPeriod",
                sortable: false,
                filterable: false,
              },
              {
                Header: "Servicios",
                accessor: "services",
                filterable: false,
              },
              {
                Header: "Precio Total",
                accessor: "totalPrice",
                sortable: false,
                filterable: false,
              },
              {
                Header: "Actions",
                accessor: "actions",
                sortable: false,
                filterable: false,
              },
            ]}
            data={this.state.packs}
            filterable
            defaultPageSize={10}
            className="-striped -highlight"
          />
        </div>
        <PacksDrawer
          pack={this.state.pack}
          handleRemove={this.handleRemove}
          openModal={this.state.openModal}
          formErrors={this.state.formErrors}
          handleAddPhone={this.handleAddPhone}
          handleEditForm={this.handleEditForm}
          isNewService={this.state.isNewService}
          handleDateChange={this.handleDateChange}
          handleFormSubmit={this.handleFormSubmit}
          handleCancelForm={this.handleCancelForm}
          handleInputChange={this.handleInputChange}
        />
        <Modal
          open={this.state.openAlert}
          title="Eliminar elemento"
          closeIcon={false}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            gap: "15px",
          }}
          footer={() => (
            <div style={{ display: "flex", gap: "6px" }}>
              <Button onClick={() => this.setState({ openAlert: false })}>
                Cancelar
              </Button>
              <Button
                onClick={() => {
                  this.handleDeleteService(this.state.current_uuid);
                  this.setState({ openAlert: false });
                }}
                type="primary"
                danger={true}
              >
                Eliminar
              </Button>
            </div>
          )}
        >
          ¿Deseas eliminar el elemento?
        </Modal>
      </div>
    );
  }
}

export default SpecialPacks;



// WEBPACK FOOTER //
// ./src/views/Configurator/Tabs/SpecialPacks.jsx